import React, { useEffect, useState } from "react";
import "./TagComponent.css";

const TagComponent = ({
  tag,
  isSelected,
  onClick,
  tagsDefaultColors,
  onMouseEnter,
  onMouseLeave,
}) => {
  const [tagColor, setTagColor] = useState(
    tag.color || (tagsDefaultColors && tagsDefaultColors[tag.id])
  );

  useEffect(() => {
    if (!tagColor) {
      setTagColor(tagsDefaultColors[tag.id]);
    }
  }, [Object.keys(tagsDefaultColors).length]);

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`tag-component`}
      style={{
        border: `1px solid ${tagColor}80`,
        backgroundColor: `${tagColor}10`,
      }}
      onClick={onClick}
    >
      <span className="tag-name" style={{ color: tagColor }}>
        {tag.name}
      </span>
    </div>
  );
};

export default TagComponent;
